import React from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";
import { WINDOWS, refreshMs } from "./monUtil";

export function WindowPills({ win, setWin, testid = "mon-window" }) {
  return (
    <div className="inline-flex rounded-xl border border-line bg-white p-0.5" data-testid={testid}>
      {WINDOWS.map((w) => (
        <button key={w} onClick={() => setWin(w)} className={`rounded-[10px] px-3 py-1.5 text-xs font-bold transition-colors ${win === w ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-900"}`} data-testid={`${testid}-${w}`}>{w}</button>
      ))}
    </div>
  );
}

export function MonToolbar({ prefs, onRefresh, loading, at, showAuto = true }) {
  return (
    <>
      <WindowPills win={prefs.win} setWin={prefs.setWin} />
      {showAuto && (
        <button onClick={() => prefs.setAuto(!prefs.auto)} className="btn-soft rounded-xl px-3 py-2 text-xs" data-testid="mon-auto-toggle" aria-pressed={prefs.auto}>
          <span className={`relative flex h-2 w-2 ${prefs.auto ? "" : "opacity-40"}`}>
            {prefs.auto && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />}
            <span className={`relative inline-flex h-2 w-2 rounded-full ${prefs.auto ? "bg-emerald-500" : "bg-slate-400"}`} />
          </span>
          Auto {refreshMs(prefs.win) / 1000} dtk {prefs.auto ? "aktif" : "mati"}
        </button>
      )}
      <button onClick={onRefresh} disabled={loading} className="btn-soft rounded-xl px-3 py-2 text-xs" data-testid="mon-refresh"><RefreshCw size={13} className={loading ? "animate-spin" : ""} /> Segarkan</button>
      {at && <span className="text-[11px] text-slate-400" data-testid="mon-updated-at">Diperbarui {at.toLocaleTimeString("id-ID", { timeZone: "Asia/Jakarta" })} WIB</span>}
    </>
  );
}

export function MonError({ msg, testid = "mon-error" }) {
  if (!msg) return null;
  return <div className="mb-4 flex items-center gap-2 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-700" data-testid={testid}><AlertTriangle size={16} /> {msg}</div>;
}

export function Bar({ pct, tint, testid }) {
  return <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100"><div className={`h-full rounded-full ${tint} transition-[width] duration-500`} style={{ width: `${Math.min(100, Math.max(0, pct || 0))}%` }} data-testid={testid} /></div>;
}
